import { getSiteName, GetSiteNameInput } from '@provision/formatting-utils';
import { ActivityFeed } from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';
import { ActivityFeedTime } from './acitivity-feed-time';
import { ChatActivityContainer } from './chat-activity-container';
import { StyledTypography } from './styled/typography.styled';

interface TemplateChangeFields extends GetSiteNameInput {
  brandName: string;
}

export const ConversationToAddressActivityMessage = ({
  activity,
  action,
}: {
  activity: ActivityFeed;
  action: 'create' | 'delete';
}) => {
  const address = activity.changes.reduce(
    (acc, item) => ({
      ...acc,
      [item.name]: item.value,
    }),
    {} as TemplateChangeFields,
  );

  const fullAddress = getSiteName(address);
  const icon = address.brandName?.toLowerCase().includes('commercial') ? 'domain' : 'home';
  const text =
    action === 'create'
      ? 'associated conversation with site'
      : 'disassociated conversation from the site';
  return (
    <ChatActivityContainer
      icon={icon}
      title={
        <StyledTypography>
          <b>{activity.actor.name}</b> {text}: <b>{fullAddress}</b>{' '}
          <ActivityFeedTime activity={activity} />
        </StyledTypography>
      }
    />
  );
};
